import { render, staticRenderFns } from "./IncomeStatistics2.vue?vue&type=template&id=29fd9eb6&scoped=true&"
import script from "./IncomeStatistics2.vue?vue&type=script&lang=js&"
export * from "./IncomeStatistics2.vue?vue&type=script&lang=js&"
import style0 from "./IncomeStatistics2.vue?vue&type=style&index=0&id=29fd9eb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd9eb6",
  null
  
)

export default component.exports